import { render, staticRenderFns } from "./updateConsultation.vue?vue&type=template&id=13ac3fa0&"
import script from "./updateConsultation.vue?vue&type=script&lang=js&"
export * from "./updateConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports